import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const textButtonDefaultVariants = {
  "color": "accent",
  "size": "medium"
}
const textButtonCompoundVariants = []

const textButtonSlotNames = [
  [
    "root",
    "textButton__root"
  ],
  [
    "label",
    "textButton__label"
  ],
  [
    "icon",
    "textButton__icon"
  ]
]
const textButtonSlotFns = /* @__PURE__ */ textButtonSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, textButtonDefaultVariants, getSlotCompoundVariant(textButtonCompoundVariants, slotName))])

const textButtonFn = memo((props = {}) => {
  return Object.fromEntries(textButtonSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const textButtonVariantKeys = [
  "color",
  "size"
]
const getVariantProps = (variants) => ({ ...textButtonDefaultVariants, ...compact(variants) })

export const textButton = /* @__PURE__ */ Object.assign(textButtonFn, {
  __recipe__: false,
  __name__: 'textButton',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: textButtonVariantKeys,
  variantMap: {
  "color": [
    "accent",
    "neutral",
    "passive",
    "buy",
    "sell"
  ],
  "size": [
    "large",
    "medium",
    "small"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, textButtonVariantKeys)
  },
  getVariantProps
})